import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { fadeIn, navVariants, staggerContainer } from "../utils/motion";
import { motion } from "framer-motion";
import logo from "../assets/images/QPAfricaLogo.svg";

const NavBar = () => {
  const [nav, setNav] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (nav) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [nav]);

  return (
    <motion.div
      variants={navVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: "true" }}
      className="absolute sm:top-5 left-0 right-0 justify-center py-5 sm:py-0 sm:bg-black bg-black sm:px-4 sm:mx-auto max-w-screen-lg z-10 sm:rounded-3xl"
    >
      <div className="container px-6 sm:px-0 flex items-center justify-between sm:mx-auto">
        <Link to="/" className="items-center ml-3">
          <span className="self-center text-xl font-semibold whitespace-nowrap text-white">
            <img src={logo} alt="QPAfrica Logo" />
          </span>
        </Link>
        <button
          data-collapse-toggle="navbar-default"
          type="button"
          className="items-center border-gray-100 block sm:hidden p-2 ml-3 text-sm text-gray-200 rounded-lg focus:outline-none"
          aria-controls="navbar-default"
          aria-expanded={nav}
          onClick={() => setNav(!nav)}
        >
          <svg
            className="w-6 h-6"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
        <div className="sm:block hidden w-full sm:w-auto" id="navbar-default">
          <div
            className={`flex flex-col p-4 mt-4 rounded-lg bg-transparent sm:flex-row sm:mt-0 sm:font-medium md:border-0 md:bg-transparent`}
          >
            <Link
              className={`${
                location.pathname === "/partners" && "bg-gray-600 text-gray-300"
              } block mr-2 hover:duration-300 ease-in-out py-2 pl-3 pr-4 rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300 dark:hover:bg-gray-700`}
              to="/partners"
            >
              Partner
            </Link>
            <Link
              className={`${
                location.pathname === "/contact" && "bg-gray-600 text-gray-300"
              } block mr-2 duration-300 ease-in-out py-2 pl-3 pr-4 rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300 dark:hover:bg-gray-700`}
              to="/contact"
            >
              Contact
            </Link>
            {/* <Link
              className={`${
                location.pathname === "/blogs" && "bg-gray-600 text-gray-300"
              } block mr-2 duration-300 ease-in-out py-2 pl-3 pr-4 rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300 dark:hover:bg-gray-700`}
              to="/blogs"
            >
              Blog
            </Link> */}
            <Link
              className={`${
                location.pathname === "/about" && "bg-gray-600 text-gray-300"
              } block mr-2 duration-300 ease-in-out py-2 pl-3 pr-4 rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300 dark:hover:bg-gray-700`}
              to="/about"
            >
              About
            </Link>

            <a
              target="_blank"
              href="https://atafrica.zohorecruit.com/careers"
              className="block mr-2 duration-300 ease-in-out py-2 pl-3 pr-4 rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300 dark:hover:bg-gray-700"
              rel="noreferrer"
            >
              Career
            </a>
          </div>
        </div>
      </div>
      {nav && (
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: "false", amount: 0.1 }}
        >
          <motion.div
            variants={fadeIn("down", "spring", 0.2, 0.75)}
            onClick={() => setNav(false)}
            className="fixed sm:hidden inset-0 bg-gray-300/60 backdrop-blur min-w-full min-h-screen right-0 top-20 z-30"
          ></motion.div>
          <motion.div
            variants={fadeIn("down", "spring", 0.2, 0.75)}
            className="flex px-6 py-10 absolute z-30 top-18 w-full sm:hidden flex-col gap-y-3 rounded-b-lg bg-black sm:mt-0 sm:font-medium md:border-0 sm:bg-gray-900"
          >
            <Link
              to="/partners"
              className={` ${
                location.pathname === "/partners" && "bg-gray-600 text-gray-300"
              } block py-2 pl-3 duration-300 ease-in-out pr-4 rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300`}
              aria-current="page"
            >
              Partner
            </Link>
            <Link
              to="/contact"
              className={` ${
                location.pathname === "/contact" && "bg-gray-600 text-gray-300"
              } block py-2 pl-3 pr-4 duration-300 ease-in-out rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300`}
            >
              Contact
            </Link>
            {/* <Link
              to="/blogs"
              className={` ${
                location.pathname === "/blogs" && "bg-gray-600 text-gray-300"
              } block py-2 pl-3 pr-4 duration-300 ease-in-out rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300`}
            >
              Blog
            </Link> */}
            <Link
              to="/about"
              className={` ${
                location.pathname === "/about" && "bg-gray-600 text-gray-300"
              } block py-2 pl-3 pr-4 duration-300 ease-in-out rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300`}
            >
              About
            </Link>
            <a
              target="_blank"
              href="https://atafrica.zohorecruit.com/careers"
              className="block mr-2 duration-300 ease-in-out py-2 pl-3 pr-4 rounded text-gray-300 hover:bg-gray-600 hover:text-gray-300 dark:hover:bg-gray-700"
              rel="noreferrer"
            >
              Career
            </a>
          </motion.div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default NavBar;
